import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

const monthList = [
    {
        value: 1,
        label: '4주(28일)',
    },
    {
        value: 2,
        label: '8주(56일)',
    },
    {
        value: 3,
        label: '12주(84일)',
    },
    {
        value: 4,
        label: '16주(112일)',
    },
    {
        value: 5,
        label: '20주(140일)',
    },
    {
        value: 6,
        label: '24주(168일)',
    },
    {
        value: 7,
        label: '28주(196일)',
    },
    {
        value: 8,
        label: '32주(224일)',
    },
    {
        value: 9,
        label: '36주(252일)',
    },
    {
        value: 10,
        label: '40주(280일)',
    },
    {
        value: 11,
        label: '44주(308일)',
    },
    {
        value: 12,
        label: '48주(336일)',
    },
    {
        value: 13,
        label: '52주(364일)',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
}));

export default function CabinetUse(props) {
    const classes = useStyles();

    const [month, setMonth] = React.useState();
    const [cabinet, setCabinet] = React.useState();
    const [startDateTime, setStartDateTime] = React.useState();

    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const onMonthChange = event => {
        setMonth(event.target.value);
        setBill(event.target.value, cabinet);
    };
    
    useEffect(() => {

        //현재 사물함 정보
        fetchDefault('/Cabinet/GetCurrentCabinet?cabinetUseId=' + props.match.params.cabinetUseId,
            (data) => {
                if (data.cabinetId) {
                    setCabinet(data.cabinetId);
                    setStartDateTime(data.endDateTime);
                    setBill(month, data.cabinetId);
                }
            }
        );

        return () => {
        }
    }, []);

    const setBill = (month, cabinetId) => {
        fetchDefault('/Cabinet/GetCabinetBill?cabinetId=' + cabinetId + '&month=' + month,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }


    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>사물함 연장하기</h2>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 연장하실 기간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="기간"
                        className={classes.textField}
                        value={month}
                        onChange={onMonthChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {monthList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint}  totalPrice={totalPrice} />
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Cabinet/PayCabinet?startDateTime=' + startDateTime + '&cabinetId=' + cabinet + '&month=' + month} />
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/CabinetUseExtend.js